import React from 'react';
import { LinkIconButton } from '@atlaskit/button/new';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useNavigateBack } from '../../controllers/navigate-back-context/index.tsx';
import messages from './messages.tsx';

export function BackButton(): React.JSX.Element {
	const { formatMessage } = useIntl();
	const { previousUrl } = useNavigateBack();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<Tooltip content={formatMessage(messages.tooltip)} hideTooltipOnMouseDown>
			<LinkIconButton
				href={previousUrl || ''}
				appearance="subtle"
				spacing="compact"
				icon={ArrowLeftIcon}
				label={formatMessage(messages.label)}
				onClick={() => {
					fireUIAnalytics(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
				}}
			/>
		</Tooltip>
	);
}
